import {
  red,
  pink,
  purple,
  deepPurple,
  indigo,
  blue,
  lightBlue,
  cyan,
  teal,
  green,
  lightGreen,
  lime,
  yellow,
  amber,
  orange,
  deepOrange,
  brown,
  grey,
  blueGrey,
} from "@mui/material/colors";

const shade = 600;
const transparencyShade = 50;

export const materialColors: { [key: string]: string } = {
  red: red[shade],
  pink: pink[shade],
  purple: purple[shade],
  deepPurple: deepPurple[shade],
  indigo: indigo[shade],
  blue: blue[shade],
  lightBlue: lightBlue[shade],
  cyan: cyan[shade],
  teal: teal[shade],
  green: green[shade],
  lightGreen: lightGreen[shade],
  lime: lime[shade],
  yellow: yellow[shade],
  amber: amber[shade],
  orange: orange[shade],
  deepOrange: deepOrange[shade],
  brown: brown[shade],
  grey: grey[shade],
  blueGrey: blueGrey[shade],
};

export const materialColorsForSelect = [
  { name: "Red", value: red[shade] },
  { name: "Cyan", value: cyan[shade] },
  { name: "Pink", value: pink[shade] },
  { name: "Green", value: green[shade] },
  { name: "Purple", value: purple[shade] },
  { name: "Yellow", value: yellow[shade] },
  { name: "Deep Purple", value: deepPurple[shade] },
  { name: "Grey", value: grey[shade] },
  { name: "Light Blue", value: lightBlue[shade] },
  { name: "Indigo", value: indigo[shade] },
  { name: "Teal", value: teal[shade] },
  { name: "Light Green", value: lightGreen[shade] },
  { name: "Blue", value: blue[shade] },
  { name: "Lime", value: lime[shade] },
  { name: "Orange", value: orange[shade] },
  { name: "Deep Orange", value: deepOrange[shade] },
  { name: "Brown", value: brown[shade] },
  { name: "Blue Grey", value: blueGrey[shade] },
];

export const materialTransparentColors: { [key: string]: string } = {
  [red[shade]]: red[transparencyShade],
  [pink[shade]]: pink[transparencyShade],
  [purple[shade]]: purple[transparencyShade],
  [deepPurple[shade]]: deepPurple[transparencyShade],
  [indigo[shade]]: indigo[transparencyShade],
  [blue[shade]]: blue[transparencyShade],
  [lightBlue[shade]]: lightBlue[transparencyShade],
  [cyan[shade]]: cyan[transparencyShade],
  [teal[shade]]: teal[transparencyShade],
  [green[shade]]: green[transparencyShade],
  [lightGreen[shade]]: lightGreen[transparencyShade],
  [lime[shade]]: lime[transparencyShade],
  [yellow[shade]]: yellow[transparencyShade],
  [amber[shade]]: amber[transparencyShade],
  [orange[shade]]: orange[transparencyShade],
  [deepOrange[shade]]: deepOrange[transparencyShade],
  [brown[shade]]: brown[transparencyShade],
  [grey[shade]]: grey[transparencyShade],
  [blueGrey[shade]]: blueGrey[transparencyShade],
};

export const defaultMaterialColor = () => {
  return "#ffffff";
};
